import 'nouislider/dist/nouislider.css'; // Подключаем стили
import noUiSlider from 'nouislider';  
import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';
import Choices from 'choices.js';
import 'choices.js/public/assets/styles/choices.min.css';



document.addEventListener('DOMContentLoaded', function(){


  function debounce(func, timeout = 300) {
    let timer;
    return (...args) => {
      clearTimeout(timer);
      timer = setTimeout(() => { func.apply(this, args); }, timeout);
    };
  }



const creditPage = document.querySelector('.credit-page');


  const commonConfig = {
  itemSelectText: 'Выбрать',
  searchPlaceholderValue: 'Поиск...',
  noResultsText: 'Не найдено...',
  searchEnabled: false
};
const selectors = [
  { selector: '.f-brand', options: { searchEnabled: false } },
  { selector: '.f-model', options: { searchEnabled: false } },
];  


const choicesInstances = {};


  selectors.forEach(({ selector, options = {} }) => {
    const element = document.querySelector(selector);
    if (element) {
      choicesInstances[selector] = new Choices(element, { 
        ...commonConfig, 
        ...options 
      });
    }
  });


const brandElement = document.querySelector('.f-brand');
    brandElement.addEventListener('change', debounce(async (e) => {
      const brandId = e.detail.value;
      const modelChoices = choicesInstances['.f-model'];
      modelChoices.removeActiveItems();
    // modelChoices.setChoices([{ value: '', label: 'Ошибка загрузки', disabled: true }]);

      try {
        const response = await fetch(`/api/models?brand_id=${brandId}`);
        const models = await response.json();
        if (models.data.length > 0) {
          modelChoices.setChoices(
            models.data.map(model => ({
              value: model.id,
              label: model.title
            })),
            'value',
            'label',
            true
          );
        } else {
          modelChoices.setChoices([{ value: '', label: 'Нет моделей для этого бренда', disabled: true }]);
        }
      } catch (error) {
        console.error('Error loading models:', error);
        modelChoices.setChoices([{ value: '', label: 'Ошибка загрузки', disabled: true }]);
      }
    }));


  if (choicesInstances['.f-model']) {
    choicesInstances['.f-model'].setChoices(
      [{ value: '', label: 'Сначала выберите бренд', disabled: true }],
      'value',
      'label',
      true
    );
  }











function updateActiveCarCard(activeIndex) {
  // Убираем активный класс у всех карточек
  document.querySelectorAll('.credit-swiper .car-card').forEach((card) => {
    card.classList.remove('active');
  });

  // Находим текущий слайд и добавляем класс его car-card
  const currentSlide = document.querySelectorAll('.swiper-slide')[activeIndex];
  if (currentSlide) {
    const carCard = currentSlide.querySelector('.car-card');
    if (carCard) {
      carCard.classList.add('active');
      carCard.click();
    }
  }
}




const modelElement = document.querySelector('.f-model');

     const swiperWrapper = document.querySelector('.swiper-wrapper');
     const swiperButtons = document.querySelector('.swiper-buttons');







  modelElement.addEventListener('change', debounce(async (e) => {
      const modelId = e.detail.value;


  try {
    swiperWrapper.innerHTML = '<div class="loading">Загрузка...</div>';
  const response = await fetch(`/api/get-cars-by-model-id`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ modelId }),
  });

  if (!response.ok) {
    const errorText = await response.text(); // Читаем текст ошибки
    throw new Error(`HTTP error! Status: ${response.status}, Response: ${errorText}`);
  }

  const models = await response.json(); // Парсим JSON только если ответ успешный
  if (models.data.length > 0) {
      swiperButtons.style.opacity = 1;
  // Контейнер слайдов
      swiperWrapper.innerHTML = '';

        models.data.forEach((car) => {
        const slide = document.createElement('div');
        slide.className = 'swiper-slide';
        slide.innerHTML = `
          <div class="car-card">
            <div class="car-card-choise"></div>
            <div class="car-card-id">№ ${car.id}</div>
            <img src="/iwebp/${car.id}/${car.first_photo}-sm.webp" alt="${car.title}">
            <div class="car-card-title">${car.brandTitle} ${car.model} ${car.modification}</div>
            <div class="car-card-price"> ${car.discount_price} ₽</div>
            <p> ${car.year} г., Пробег: ${car.mileage} км</p>
            <p>${car.modification}, ${car.transmission}, ${car.drive} </p>
           </div>
        `;
        swiperWrapper.appendChild(slide);
      
      });

      const activeSlide = document.querySelector('.car-card');
      activeSlide.classList.add('active');
      activeSlide.click();
        if (window.carSwiper) {
        window.carSwiper.update(); // Если Swiper уже есть
      } else {
        window.carSwiper = new Swiper('.credit-swiper', {
                loop: false,
            slidesPerView: 3,
            spaceBetween: 30,
  on: {
    activeIndexChange: function () {
      updateActiveCarCard(this.activeIndex);
    },
  },
          pagination: { el: '.swiper-pagination' },
          navigation: { nextEl: '.swiper-button-n', prevEl: '.swiper-button-p' },
                                     breakpoints: {
    // when window width is >= 320px
    320: {
      slidesPerView: 1,
        
    },
      768: {
      slidesPerView: 3,
    },
  },
        });
      }


  } else {
    // Нет данных
  }
} catch (error) {
  console.error('Error:', error);
  // Показываем пользователю ошибку
}
    }));




let valuesForSlider = [0,2000000,4000000,6000000,8000000];
let valuesForSliderPay = [0,20,40,60,80,100];
let valuesForSliderMonth = [0,12,36,60,84,96];



let sumSlider = document.querySelector('.credit__sum');
let downPaySlider = document.querySelector('.credit__downpay');
let loanTermSlider = document.querySelector('.credit__loanterm');

const sliders = {
    sum: { element: sumSlider, name: 'Sum Slider' },
    downPay: { element: downPaySlider, name: 'Down Payment Slider' },
    loanTerm: { element: loanTermSlider, name: 'Loan Term Slider' }
};


function formatPrice(price) {
    return Number(price).toLocaleString('ru-RU', {
        maximumFractionDigits: 0,
        useGrouping: true
    }).replace(/,/g, ' ');
}

let formatForSlider = {
    from: function (formattedValue) {
        return Number(formattedValue);
    },
    to: function(numericValue) {
        return formatPrice(numericValue) +' ₽' ;
    }
};

let formatDownPayForSlider = {
    from: function (formattedValue) {
 
        return Number(formattedValue);
            
    },
    to: function(numericValue) {
                  const Price = document.querySelector('.c-cred-sum').textContent;
   
        return formatPrice(numericValue) +' %' ;
    }
};
let formatLoanTermSlider = {
    from: function (formattedValue) {
        return Number(formattedValue);
    },
    to: function(numericValue) {
 

        return formatPrice(numericValue) +' мес.' ;
    }
};






noUiSlider.create(sumSlider, {
    start: 1250000,
    behaviour: 'tap',
    connect: [true, false],
    range: { min: 0, max: 8000000},
    format: formatForSlider,
    tooltips: true,
    step:1000,
     pips: {
        mode: 'values',
        values:valuesForSlider,
        density: 8,
        stepped: false,
       format: formatForSlider,
    },
     
});


noUiSlider.create(downPaySlider, {
    start: 0,
    behaviour: 'tap',
    connect: [true, false],
    range: { min: 0, max: 100},
    format: formatDownPayForSlider,
       tooltips:  { to: function(value) {
        const price = document.querySelector('.c-cred-sum').textContent;
        return formatPrice((returnOnlyNumbers(price) / 100) * value) + ' ₽ ('+value+' %)'; }
       },
    step:1,
     pips: {
        mode: 'values',
        values:valuesForSliderPay,
        density: 8,
        stepped: false,
       format: formatDownPayForSlider,
    },
     
});
noUiSlider.create(loanTermSlider, {
    start: 60,
    behaviour: 'tap',
    connect: [true, false],
    range: { min: 0, max: 96},
    format: formatLoanTermSlider,
    tooltips: true,
    step:6,
    padding:[6,0],
     pips: {
        mode: 'values',
        values:valuesForSliderMonth,
        density: 8,
        stepped: false,
       format: formatLoanTermSlider,
    },
     
});


function returnOnlyNumbers(string) {
    const clearString = String(string).replace(/\D/g, '');
    const numeric = parseInt(clearString) || 0;
    return numeric;
}





function calculateLoan(carPrice, percent, month) {
      const numericCarPrice = returnOnlyNumbers(carPrice);
      const initPay = numericCarPrice / 100 * returnOnlyNumbers(percent);
    const interestRate = window.creditRate; // Годовая ставка 7.2%
    const loanAmount = numericCarPrice - initPay; // Сумма кредита

    // Месячная процентная ставка
    const monthlyRate = interestRate / 12 / 100;
    const loanTermMonths = returnOnlyNumbers(month);
    // Расчёт аннуитетного платежа
    const annuityPayment = loanAmount * 
        (monthlyRate * Math.pow(1 + monthlyRate, loanTermMonths)) / 
        (Math.pow(1 + monthlyRate, loanTermMonths) - 1);
    
    // Общая сумма к возврату
    const totalPayment = annuityPayment * loanTermMonths;
    
    // Переплата по кредиту
    const overpayment = totalPayment - loanAmount;
    
    return {
        monthlyPayment: Math.round(annuityPayment), // Ежемесячный платёж (округлённый)
        totalPayment: Math.round(totalPayment),     // Общая сумма выплат
        overpayment: Math.round(overpayment)        // Переплата
    };
}


function getAllSliderValues() {
    return {
        sum: sliders.sum.element.noUiSlider.get(),
        downPay: sliders.downPay.element.noUiSlider.get(),
        loanTerm: sliders.loanTerm.element.noUiSlider.get()
    };
}

function handleSliderUpdate() {
    const allValues = getAllSliderValues();
   let perMonth  = calculateLoan(allValues.sum,allValues.downPay,allValues.loanTerm);
    const monthPay = document.querySelector('.month-pay');
    const creditSum = document.querySelector('.c-cred-sum');
    const firstPayContainer = document.querySelector('.c-cred-pay');
    const creditMonths = document.querySelector('.c-cred-month');
    const message = document.querySelector('input[name="message"]');
    const mobilePlate = document.querySelector('.credit__plate');
    const mobilePlatePrice = document.querySelector('.credit__plate-price span');  
    const mobilePlateCredit = document.querySelector('.credit__plate-credit span'); 
      const checkIfCarActive = document.querySelector('.credit-swiper .car-card');

      const mobileHighLightCredit = document.querySelector('.total__payment .cost span');
      const mobileHighLightCreditCont = document.querySelector('.total__payment');

    const totalCreditSum = returnOnlyNumbers(allValues.sum);

    const firstPayment = (totalCreditSum / 100) *  returnOnlyNumbers(allValues.downPay);
    firstPayContainer.textContent = (firstPayment)+ ' ₽';
    creditSum.textContent = formatPrice(totalCreditSum)+ ' ₽';
    mobilePlatePrice.textContent= formatPrice(totalCreditSum);
    monthPay.textContent = formatPrice(perMonth.monthlyPayment) + ' ₽/мес';
    creditMonths.textContent = allValues.loanTerm;

    message.value = 'Сумма кредита: '+totalCreditSum;
           animateValueChange(monthPay, formatPrice(perMonth.monthlyPayment) + ' ₽/мес');
           animateValueChange(mobilePlateCredit, formatPrice(perMonth.monthlyPayment));
           animateValueChange(mobileHighLightCredit, formatPrice(perMonth.monthlyPayment));
      if (window.innerWidth <= 768 && checkIfCarActive) {
        mobilePlate.classList.add('active')
        mobileHighLightCreditCont.classList.add('active')
      }


}


    
Object.values(sliders).forEach(slider => {
    slider.element.noUiSlider.on('update', handleSliderUpdate);
});

const carInput = document.querySelector('input[name="car"]');
const brandInput = document.querySelector('input[name="brand"]');



document.querySelector('.swiper-cont').addEventListener('click', function(event) {
      if (event.target.closest('.car-card')) {
          const cards = document.querySelectorAll('.car-card');
          cards.forEach(ctx => {
            ctx.classList.remove('active');

          })


        event.target.closest('.car-card').classList.toggle('active');
        const price = event.target.closest('.car-card').querySelector('.car-card-price').textContent;
        sumSlider.noUiSlider.set(returnOnlyNumbers(price))
        let model =   choicesInstances['.f-model'].getValue();
        let brand =   choicesInstances['.f-brand'].getValue();
         carInput.value = model.label;
         brandInput.value = brand.label;
    }
    
    // Альтернативный вариант проверки по тегу
    // if (event.target.tagName === 'BUTTON') {
    //     // Обработка клика по кнопке
    // }
});



  function animateValueChange(element, newValue) {
    element.classList.add('value-change');
    element.textContent = newValue;
    element.addEventListener('animationend', () => {
      element.classList.remove('value-change');
    }, {once: true});
  }



  document.querySelector('.credit__plate-button').addEventListener('click', () => {
    // const sendForm = document.querySelector('.credit-form-point');
    // if (sendForm) {
    //     const offset = 10; // Отступ в пикселях
    //     const elementPosition = sendForm.getBoundingClientRect().top;
    //     const offsetPosition = elementPosition + window.pageYOffset - offset;

       
    //     window.scrollTo({
    //         top: offsetPosition,
    //         behavior: 'smooth'
    //     });
    // }
    handleCarRequest();
});



function handleCarRequest() {
  const title = document.querySelector('.car-card.active .car-card-title').textContent;    
  const price = document.querySelector('.car-card.active .car-card-price').innerHTML;

  
  const info = `<div class="flex">
    <div class="text">
        <div class="title">${title}</div>
        <div class="price">${price}</div>
    </div>
  </div>`;

  const params = {
    title: 'Приобрести в кредит:',
    info: info,
    message: title,
    type: 'credit_page_modal'
  };
  
  showModalForm(params);
}




});